// Italian Codice Fiscale validation (client-side mirror of backend)
const ODD = {
  '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
  A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21,
  K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14,
  U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23,
};

const EVEN = (() => {
  const m = {};
  for (let i = 0; i < 26; i++) m[String.fromCharCode(65 + i)] = i;
  for (let d = 0; d < 10; d++) m[String(d)] = d;
  return m;
})();

export function isValidCF(cf) {
  if (!cf) return false;
  const v = cf.trim().toUpperCase();
  if (v.length !== 16) return false;
  if (!/^[A-Z0-9]{15}[A-Z]$/.test(v)) return false;
  let total = 0;
  for (let i = 0; i < 15; i++) {
    const ch = v[i];
    if ((i + 1) % 2 === 0) total += EVEN[ch] || 0;
    else total += ODD[ch] || 0;
  }
  const check = String.fromCharCode(65 + (total % 26));
  return check === v[15];
}
